import { useCreateGym } from "../mutations/useCreateGym";
import { useUpdateGym } from "../mutations/useUpdateGym";
import { useDeleteGym } from "../mutations/useDeleteGym";

export const useGymMutations = () => {
  const { createNewGym } = useCreateGym();
  const { updateGym } = useUpdateGym();
  const { deleteGym } = useDeleteGym();

  return {
    createNewGym,
    updateGym,
    deleteGym,
  };
};